import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
import { Text } from '../../atoms/text/text';
import { Label } from '../label/label';
import styles from './check-input-card.module.scss';
/**
 * `CheckInputCard` is a card component that displays an image, a label, and a checkbox or radio input.
 * It provides a structured way to combine an image and a form element (Checkbox/Radio) within a card layout.
 *
 * @property {ReactElement<typeof Radio | typeof Checkbox>} [children] - The checkbox or radio input component.
 * @property {string} [className] - Additional CSS classes for the wrapper element.
 * @property {string} copy - The text content displayed below the input element.
 * @property {React.ReactElement<typeof Image>} image - The `Image` component to be displayed inside the card.
 * @property {string} label - The label text displayed alongside the input component.
 *
 * @example
 * ```tsx
 * <CheckInputCard
 *   copy="Select your option"
 *   image={<Image src="image.jpg" alt="Example Image" />}
 *   label="Choose an option"
 * >
 *   <Radio name="example" value="option1" />
 * </CheckInputCard>
 * ```
 */ export const CheckInputCard = ({ children, className, copy, image, label })=>// biome-ignore lint/a11y/noLabelWithoutControl: input expected as child
    /*#__PURE__*/ _jsxs("label", {
        className: classNames(styles.card, className),
        children: [
            image && /*#__PURE__*/ _jsx("span", {
                className: styles['image-wrapper'],
                children: image
            }),
            /*#__PURE__*/ _jsxs("span", {
                className: styles['input-wrapper'],
                children: [
                    children,
                    /*#__PURE__*/ _jsx(Label, {
                        bold: true,
                        renderAs: "span",
                        children: label
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Text, {
                children: copy
            })
        ]
    });

//# sourceMappingURL=index.js.map